export const DEFAULT_QUESTIONNAIRE_TOOLTIP = 'This questionnaire is automatically attached to all newly created jobs.';

// No trailing punctuation -- callers append either " at <email>" (once the
// live GET /api/v1/company/relationship-manager-email lookup resolves) or a
// period on its own when the email isn't available yet/failed to load.
export const EASY_APPLY_TOOLTIP_MESSAGE = 'Easy Apply must be enabled to attach a questionnaire. Questions on how to turn on Easy Apply? Get in touch with your Relationship Manager';
